module.exports = "/_next/static/images/QuranOsiris-182ff96419fc91bfe867aea45df36532.webp";